module.exports = __webpack_public_path__ + "a972d2db996e7e80304745b74fff68a8.pdf";